import { ELDVehicleStatus } from '@numeo/types'
import axios from 'axios'

class spotFinder {
    async get(endpoint: string, params?: Record<string, unknown>) {
        try {
            const response = await axios.get(endpoint, { params })
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }

    async post<T>(endpoint: string, data: T) {
        try {
            const response = await axios.post(endpoint, data)
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }
    async delete(endpoint: string) {
        try {
            const response = await axios.delete(endpoint)
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }
    async deleteTrucks(endpoint: string, data: { ids: string[] }) {
        try {
            const response = await axios.delete(endpoint, { data })
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }
    async put<T>(endpoint: string, data: T) {
        try {
            const response = await axios.put(endpoint, data)
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }
    async deleteBulk(endpoint: string, ids: string[]) {
        try {
            const response = await axios.delete(endpoint, { data: { ids } })
            return response.data
        } catch (error) {
            console.error('Error getting data ', error)
            throw error
        }
    }
}

export const sendLoadInfo = async (loadData: {
    routeDescription: string
    distanceMiles: number
    deadheadMiles?: number
    duration: string
    firstDriverEmail?: string
    secondDriverEmail?: string
    telegramChatId: string
    originLat: number
    originLng: number
    destinationLat: number
    destinationLng: number
    rate: number
    ratePerMile: number
    weight: number
    commodity: string
}) => {
    return await spotApi.post('/trucks/loads/send-load-info', loadData)
}

export const getTruckLocation = async (
    truckId: string,
    loadId?: string,
    /** `allowStale`: for a display only. A phone position older than two hours comes back with its time instead of an error. */
    options?: { returnAddress?: boolean; cache?: boolean; allowStale?: boolean }
): Promise<ELDVehicleStatus | null> => {
    const params: Record<string, unknown> = {}
    if (loadId) params.loadId = loadId
    if (options?.returnAddress) params.returnAddress = true
    if (options?.cache) params.cache = true
    if (options?.allowStale) params.allowStale = true
    return await spotApi.get(`/trucks/location/${truckId}`, params)
}

const spotApi = new spotFinder()
export default spotApi
